import { useEffect, useRef } from 'react';

export const useAutoAnimate = <T extends HTMLElement>() => {
    const parentRef = useRef<T>(null);

    useEffect(() => {
        if (parentRef.current) {
            const element = parentRef.current;
            element.style.transition = 'all 0.3s ease-in-out';
            return undefined;
        }
    }, []);

    return parentRef;
};